/* eslint-disable react/no-unescaped-entities */
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  BodyM,
  HeadlineM,
  HeadlineXL,
} from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';

import about from '#src/Careers/assets/about.webp';
import {
  Img,
  Section,
  StyledContainer,
  TwoColumnsContainer,
} from '#src/Careers/ui.tsx';

const StyledImg = styled(Img)`
  object-fit: contain;
  object-position: top;
  height: auto;
  width: 100%;
  &:hover {
    filter: brightness(1.25);
    transform: scale(1.02);
    transition:
      filter 0.3s ease-in-out,
      transform 0.3s ease-in-out;
  }
`;

export const About = () => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <Section $spacing>
      <StyledContainer>
        <TwoColumnsContainer image="left">
          <StyledImg
            src={about}
            height={isLaptopAndAbove ? 620 : 200}
            width={680}
            alt="About Sorare"
          />
          <Vertical gap={5}>
            <Vertical gap={3}>
              <HeadlineXL>About Sorare</HeadlineXL>
              <BodyM>
                Sorare is a real fantasy football, basketball, and baseball game
                where users, known as "Managers", collect and compete with
                officially licensed digital player cards against fellow sports
                fans around the world to win{' '}
                <a
                  href="https://twitter.com/sorare/status/1591125269884305409"
                  target="_blank"
                  rel="noreferrer"
                >
                  rewards
                </a>
                .
              </BodyM>
            </Vertical>
            <Vertical gap={2}>
              <HeadlineM>What makes Sorare different</HeadlineM>
              <BodyM>
                Managers own their digital collectible cards, and are free to
                trade, buy, sell, and play them as they wish. They control whom
                to roster week after week, season after season. Managers build
                their own dynasties.
              </BodyM>
            </Vertical>
          </Vertical>
        </TwoColumnsContainer>
      </StyledContainer>
    </Section>
  );
};
